import StandardModal from "components/Layout/StandardModal";
import React, { useContext, useEffect, useState } from "react";
import AgoraRTC, {
  IAgoraRTCClient,
  IMicrophoneAudioTrack,
} from "agora-rtc-sdk-ng";
import { BuildingContext, CallStatusENUM } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import axios from "axios";

export interface AgoraOptions {
  appId: string;
  channel: string;
  token: string;
  uid: string;
}

export interface AgoraRtc {
  client: IAgoraRTCClient;
  localAudioTrack?: IMicrophoneAudioTrack;
}
export interface AgoraConfig {
  rtc: AgoraRtc;
  options: AgoraOptions;
}

export interface AgoraPTTProps {
  open: boolean;
  onCancel?: () => void;
  callStatus?: CallStatusENUM;
}

interface AgoraPTTState {
  callOpen: boolean;
}

const DEFAULT_STATE: AgoraPTTState = {
  callOpen: false,
};

export default function AgoraPTT({
  open,
  callStatus,
  onCancel,
}: AgoraPTTProps) {
  const [state, setstate] = useState(DEFAULT_STATE);
  const { getDatabase, user } = useContext(AuthContext);
  const { currentBuilding, updateBuilding, buildingState } =
    useContext(BuildingContext);

  const startBasicCall = async () => {
    /**
     * Put the following code snippets here.
     */
  };

  const initAgora = async () => {};

  const updateCallStatus = async () => {
    const client: IAgoraRTCClient = AgoraRTC.createClient({
      mode: "rtc",
      codec: "vp8",
    });
    try {
      if (user?.getIdToken() && currentBuilding) {
        const token = await user?.getIdToken(true);
        if (!!token) {
          const config = {
            headers: {
              token: token,
              buildingId: currentBuilding.Id,
            },
          };
          axios
            .get(`/api/getAgoraToken`, config)
            .then(async (data) => {
              let rtc: AgoraRtc = {
                client: client,
              };

              const options: AgoraOptions = {
                // Pass your app ID here.
                appId: data.data.appId,
                uid: data.data.uid,
                // Set the channel name.
                channel: currentBuilding.Id,
                // Pass a token if your project enables the App Certificate.
                token: data.data.token,
              };
              console.log(
                "🚀 ~ file: BuildingProvider.tsx ~ line 113 ~ .then ~ options",
                options
              );

              if (callStatus === CallStatusENUM.OPEN && !state.callOpen) {
                if (client && options) {
                  await rtc.client.join(
                    options.appId,
                    options.channel,
                    options.token,
                    options.uid
                  );

                  rtc.localAudioTrack =
                    await AgoraRTC.createMicrophoneAudioTrack();
                  // Publish the local audio track to the channel.
                  await rtc.client.publish([rtc.localAudioTrack]);
                  rtc.client.on("user-published", async (user, mediaType) => {
                    // Subscribe to a remote user.
                    await rtc.client.subscribe(user, mediaType);

                    // If the subscribed track is audio.
                    if (mediaType === "audio") {
                      // Get `RemoteAudioTrack` in the `user` object.
                      const remoteAudioTrack = user.audioTrack;
                      // Play the audio track. No need to pass any DOM element.
                      remoteAudioTrack?.play();
                    }
                  });
                  setstate({ ...state, callOpen: true });
                }
              } else if (callStatus === CallStatusENUM.CLOSED) {
                if (client && options) {
                  client.leave();
                  setstate({ ...state, callOpen: false });
                }
              }
            })
            .catch((err) => {
              console.log(
                "🚀 ~ file: BuildingProvider.tsx ~ line 115 ~ axios.get ~ err",
                err
              );
            });
        }
      }
    } catch (e) {}
  };

  useEffect(() => {
    console.log(
      "🚀 ~ file: AgoraPTT.tsx ~ line 59 ~ useEffect ~ callStatus",
      callStatus,
      state
    );
    if (!!callStatus) {
      updateCallStatus();
    }
  }, [callStatus]);
  return (
    <StandardModal open={open} title="Building Call" onCancel={onCancel}>
      <div>agora modal</div>
    </StandardModal>
  );
}
